import BuyNowErrorBoundary from "./BuyNowErrorBoundary";
import React from "react";
import BuyNow from "./BuyNow";

/**
 * By using a wrapper for our root component, we can surround all code with an error boundary.
 * For example, our BuyNowErrorBoundary component can capture all unhandled exceptions and log or email them.
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */
const BuyNowWrapper = props => (
  <BuyNowErrorBoundary>
    <BuyNow {...props} />
  </BuyNowErrorBoundary>
);

// solution for using hooks in parent component https://github.com/shakacode/react_on_rails/issues/1198#issuecomment-483784251
export default (props) => <BuyNowWrapper {...props} />;
